import {Square} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const CheckBoxOutlineBlankIcon = createLucideIcon(Square, 'CheckBoxOutlineBlankIcon');
